import { render } from "./Dev.vue?vue&type=template&id=5c7425b2&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"

import "./Dev.vue?vue&type=style&index=0&id=5c7425b2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7425b2"]])

export default __exports__